// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kit-status-chip.v-chip.v-size--x-small{border-radius:4px;font-size:10px;height:16px;padding:0 7px}.kit-status-chip.v-chip.v-size--x-small .v-chip__content{font-weight:700}.kit-status-chip.v-chip>.v-chip__content{font-size:10px!important;letter-spacing:.02em!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
